export enum CampaignStatus {
  Draft = "D",
  Active = "A",
  Inactive = "I",
  Rejected = "R",
  Hold = "H",
  Completed = "C",
}

export enum CampaignType {
  PromotionalPrice = 0,
  DiscountCoupon = 1,
  SimpleMessage = 2,
}

export enum CampaignFormat {
  Catalog = "CATALOG",
  Cart = "CART",
}
